import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { marketService } from 'shared/src/api';
import type { GetMarketGoodsCarouselResponse } from 'shared/src/api/marketService/getMarketGoodsCarousel/type';
import { convertMarketHomeGoodsItemToGoodsData } from '../../../utils/convertMarketHomeGoodsItemToGoodsData';
import type { QueryHookOptions } from 'shared/src/types';

export const useMarketGoodsCarouselQuery = (
  marketId: number,
  options?: QueryHookOptions<GetMarketGoodsCarouselResponse>,
) => {
  return useQuery({
    queryKey: queryKey.marketGoodsCarousel(marketId),
    queryFn: () => marketService.getMarketCarousel(marketId),
    staleTime: 0,
    select: (data: GetMarketGoodsCarouselResponse) => {
      return {
        ...data,
        components: data.components.map(component => ({
          ...component,
          entity: {
            ...component.entity,
            item_list: component.entity.item_list.map(
              convertMarketHomeGoodsItemToGoodsData,
            ),
          },
        })),
      };
    },
    ...options,
  });
};
